import styled, { css } from 'styled-components'
import { rem } from 'polished'

export const ArticleCardContainer = styled.div`
  position: relative;
  text-align: center;
  min-height: ${rem('350px')};
  height: 100%;
  background-color: #fff;
  border-radius: 2px;
`

export const ArticleImageContainer = styled.div`
${({ theme }) => {
    const tablet = theme.useMediaQuery(theme.breakpoints.down('medium'));
  return css`
    height: ${tablet ? '60%' : '50%'};
    `;
  }}
`;

export const ArticleImage = styled.img`
  position: relative;
  display: block;
  object-fit: cover;
  height: 100%;
  width: 100%;
`

export const ArticleContent = styled.div`
  padding: 1.25rem;
`

export const ActionContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 1.25rem;
  text-decoration: underline;
  line-height: ${rem('19px')};
  font-size: ${rem('14px')};
  letter-spacing: ${rem('0.45px')};
`
